// hooks/useFormValidation.ts
import { useState } from 'react';

export interface BaseContactForm {
  name: string;
  email: string;
  phone: string;
  subject: string;
  note: string;
  conditions: boolean;
}

type ValidationErrors<T> = Partial<Record<keyof T, string>>;

export const useFormValidation = <T extends BaseContactForm>() => {
  const [errors, setErrors] = useState<ValidationErrors<T>>({});

  const phoneRegex =
    /^(?:\+32|0)4\d{8}$|^(?:\+33|0)[67]\d{8}$|^(?:\+31|0)6\d{8}$|^(?:\+49|0)1\d{9,10}$/;

  const validateForm = (values: T) => {
    const newErrors: ValidationErrors<T> = {};

    if (!values.name.trim()) newErrors.name = 'Verplicht';

    if (!values.email.trim()) newErrors.email = 'Verplicht';
    else if (!/^\S+@\S+\.\S+$/.test(values.email)) newErrors.email = 'Ongeldig';

    if (!values.phone.trim()) newErrors.phone = 'Verplicht';
    else if (!phoneRegex.test(values.phone.replace(/\s/g, ''))) newErrors.phone = 'Ongeldig';

    if (!values.subject) newErrors.subject = 'Kies optie';

    if (!values.note.trim()) newErrors.note = 'Verplicht';

    if (!values.conditions) newErrors.conditions = 'Vereist';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return { errors, validateForm };
};
